import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  COL_I,
  HEADER_FILL,
  TABLE_HEADER_FILL,
  mergeRow,
  safeText,
  setCell,
} from "./principle6SheetHelpers";

const TITLE_ROW = 3;
const HEADER_ROW = 4;
const DATA_START_ROW = 5;

export const SHEET_NAME = "Public policy advocates";

const SHEET_TITLE = "Details of public policy positions advocated by the entity";

export function buildPublicPolicyAdvocatesSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: true }] });

  ws.getColumn("A").width = 2;
  ws.getColumn("B").width = 2;
  ws.getColumn("C").width = 2;
  ws.getColumn("D").width = 8;
  ws.getColumn("E").width = 20;
  ws.getColumn("F").width = 22;
  ws.getColumn("G").width = 22;
  ws.getColumn("H").width = 18;
  ws.getColumn("I").width = 18;

  const rows = sectionC?.principle7?.leadershipIndicator?.publicPolicyPositions || [];
  const dataRows = Array.isArray(rows) && rows.length ? rows : [{}];

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_7, { mergeEnd: COL_I });

  mergeRow(ws, TITLE_ROW, COL_D, COL_I, SHEET_TITLE, {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  setCell(ws, HEADER_ROW, COL_D, "Sr. no.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_E, "Public policy advocated", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  setCell(ws, HEADER_ROW, COL_F, "Method resorted for such advocacy", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  setCell(ws, HEADER_ROW, COL_G, "Whether information available in public domain? (Yes/No)", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  setCell(ws, HEADER_ROW, COL_H, "Frequency of Review by Board", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  setCell(ws, HEADER_ROW, COL_I, "Web Link, if available", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_D, String(idx + 1), { align: "center" });
    setCell(ws, row, COL_E, safeText(item?.policyAdvocated), { align: "left" });
    setCell(ws, row, COL_F, safeText(item?.advocacyMethod), { align: "left" });
    setCell(ws, row, COL_G, safeText(item?.informationInPublicDomain), { align: "center" });
    setCell(ws, row, COL_H, safeText(item?.reviewFrequencyByBoard), { align: "left" });
    setCell(ws, row, COL_I, safeText(item?.webLink), { align: "left" });
  });

  return ws;
}
